<template>
    <div id="cardDetail">
        <div  class="app-inner">
             <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="$util.reback('/ElectronicCard')" style="margin-left:0">
                返回
            </div>
            </div>
             <div class="p-tit-c">
                 <div class="businessDetail-info flex align-cen">
                     <div class="businessDetail-info-logo">
                        <img :src="info.pic ? info.pic : require('../../assets/images/user.png')" alt="">
                    </div>
                      <div class="businessDetail-info-con flex">
                        <div class="list">
                            使用者ID：{{info.id}}
                        </div>
                        <div class="list">
                            手机号：{{info.phone}}
                        </div>
                         <div class="list">
                            名片总访问量（次）：{{info.visitNum}}
                        </div>
                         <div class="list">
                            姓名：{{info.name}}
                        </div>
                        <div class="list">
                            发出名片总量（次）：{{info.shareNum}}
                        </div>
                        <div class="list">
                            今日访问量（次）：{{info.todayVisitNum}}
                        </div>
                      </div>
                 </div>
             </div>
               <div class="businessDetail-data">
                 <div class="public-tit flex align-cen" style="margin:16px 0">
                            <div class="public-tit-list">
                                <i class="icon-al-database-fill"></i>  访客信息
                            </div>
                            <div class="mft" style="cursor: pointer;" @click="exportExcel(multipleSelection)">
                                <i class="icon-al-download"></i>   导出数据
                                </div>
                        </div>
                            <el-table
                ref="multipleTable"
                :data="list"
                tooltip-effect="dark"
                style="width: 100%"
                id='mytable'
                border
                :header-cell-style="{background:'#eeeeee',color:'#666',paddingBottom:'10px'}"
                 :row-key="getRowKeyOfTarget"
                 @selection-change="handleSelectionChange"
                >
                 <el-table-column type="selection" width="55" reserve-selection align="center" fixed="left"> </el-table-column>
                     <el-table-column prop="phone" label="电话号码" align="center">
                 </el-table-column>
                   <el-table-column prop="nickname " label="用户昵称" align="center">
                       <template slot-scope="scope">
                        <p>{{scope.row.nickname || '-'}}</p>
                        </template>
                 </el-table-column>
                     <el-table-column prop="visitTime" label="访问时间" align="center">
                 </el-table-column>
                     <el-table-column prop="typeName" label="触发页面" align="center">
                          <template slot-scope="scope">
                        <p>{{scope.row.typeName || '-'}}</p>
                        </template>
                 </el-table-column>
                  </el-table>
                    <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
               </div>
               </div>
    </div>
</template>
<script>
import { vcardDetail,VcardPageVisitor} from "@/api/index/index"; // 电子名片详情查询接口、分页查询访客数据
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import exportExcel from '../../utils/exportExcel.js' //导出数据公共方法
export default {
    name:'cardDetail',
     components:{
      paginaTion,
    },
    data() {
        return {
            info:{},
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            list:[],
            multipleSelection:[]
        }
    },
    created() {
        this.getDetail()
        this.getVisitorList()
    },
    methods: { 
                   // 导出
      exportExcel(val){
        if(val.length !=0){
          let keyLisst = [] 
          for(let item in val){
             keyLisst.push( {
              '电话号码':val[item].phone, 
              '用户昵称':val[item].nickname || '-',
              '访问时间':val[item].visitTime, 
              '触发页面':val[item].typeName || '-',
              } ) 
             }
         exportExcel.exportExcel(keyLisst,'电子名片访客信息')
        }
        else{
          this.$util.Notifi('请选择导出数据','error','fa-exclamation-circle')
        }
      },
        // 分页查询访客信息
        getVisitorList(){
            let params = {
            current: this.currentPage,
            size:this.PageSize,
            id:this.$route.query.id
            }
            VcardPageVisitor(params)
            .then(res =>{
                 this.list = res.data.records
             this.totalCount = res.data.total;
            })
        },
        // 查询电子名片详情
        getDetail(){
            vcardDetail({id:this.$route.query.id})
            .then(res =>{
                this.info = res.data
            })
        },
                          // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getVisitorList()
      },
             getRowKeyOfTarget(row) {
            return row.id
            },
            // 表格选择
         handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    },
}
</script>
<style lang="scss" scoped>
#cardDetail{
    height: inherit;
     .edit-header{
        padding: 0 20px;

    }
    .businessDetail-info{
        padding: 30px 20px 20px 20px; 
        .businessDetail-info-logo{
            width: 200px;
            border-right: 1px solid #ccc;
            img{
                width: 100px;
                height: 100px;
                border-radius: 100px;
                margin: 0 auto;
                display: block;
            }
        }
        .businessDetail-info-con{
            width: calc(100% - 200px);
            padding: 0 20px;
            flex-wrap: wrap;
            .list{
                width: 31%;
                padding-right: 2%;
                padding-bottom: 20px;
               div{
                width: 70%;
                 overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
               }
            }
        }
    }
    
    .businessDetail-data{
        margin-bottom: 70px;
          .businessDetail-data-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
         .businessDetail-data-table{
            height: 200px;
            overflow: hidden;
            overflow-y: auto;
         }
                      .jiange {
      margin-top: 20px;
      margin-bottom: 20px;
    }
    }
    }
</style>